import { Component } from '@angular/core';

@Component({
  selector: 'umkt-redirect-code',
  standalone: true,
  template: '<div></div>',
})
export class RedirectCodeComponent {}

